import React, {useCallback} from 'react'
import {PageTitle} from '../../Molecules/BaseMembersPages/PageTitle'
import {ContentBlock} from '../../Molecules/BaseContentBlocks/ContentBlock'
import {ContentTitle} from '../../Molecules/BaseContentBlocks/ContentTitle'
import {ContentTopMessage} from '../../Molecules/BaseContentBlocks/ContentTopMessage'
import {NavigatorForMemberPage} from '../../../Navigator/NavigatorForMemberPage'
import {LinkIconText} from '../../Molecules/LinkIconText'
import {Spacer} from '../../../../Common/Components/Spacer'
import {useTranslation} from 'react-i18next'

type MembersDuplicatedRegisterPageProps = {
  navigator: NavigatorForMemberPage
  onLoginButtonClick?: () => void
}

export const MembersDuplicatedRegisterPage: React.VFC<MembersDuplicatedRegisterPageProps> = (
  props,
) => {
  const {t} = useTranslation('member')
  const handleLoginButtonClick = useCallback((): void => {
    if (props.onLoginButtonClick) {
      props.onLoginButtonClick()
    }
    props.navigator.goToAccountTopPage()
  }, [props.navigator, props.onLoginButtonClick])

  return (
    <>
      <PageTitle>ご案内</PageTitle>
      <ContentBlock>
        <ContentTitle>既に登録されています</ContentTitle>
        <ContentTopMessage>
          登録が完了しています。<br/>下記リンクよりログインしてください。
        </ContentTopMessage>
        <Spacer mt={'18px'} mb={'14px'}>
          <LinkIconText dataTestId={'login-button'} onClick={handleLoginButtonClick}>
            {t('ご案内.登録済み.リンクテキスト ログイン')}
          </LinkIconText>
        </Spacer>
      </ContentBlock>
    </>
  )
}
